import { useMutation } from "@apollo/client";
import { graphql } from "~/gql";

export const CREATE_PARENT_MATTER = graphql(/* GraphQL */ `
  mutation CreateParentMatter($clientId: Int!, $createInput: String!, $phases: [String!]) {
    createParentMatter(clientId: $clientId, createInput: $createInput, phases: $phases) {
      id
    }
  }
`);

export const useCreateMultiDisc = () => {
  const [create, { loading, error, data }] = useMutation(CREATE_PARENT_MATTER);
  return { createMultiDiscMatter: create, loading, error, data };
};
